export const fbq = (...args: any[]) => {
  if (typeof window !== "undefined" && "fbq" in window) {
    (window as any).fbq(...args);
  } else {
    console.warn("fbq not initialized yet:", args);
  }
};
